// import { $translate } from '@/utils/i18n';
export const tableConfig = {
    configuration: true,
    searchList: {
        searchLeftSpan: 24,
        searchRightSpan: 12,
        searchTxt: [
            {
                type: 'input',
                span: 8,
                value: 'sceneCode',
                name: '场景编码',
                clearable: true
            }, {
                type: 'input',
                span: 8,
                value: 'sceneName',
                name: '场景名称',
                clearable: true
            }, {
                type: 'input',
                span: 8,
                value: 'nodeCode',
                name: '节点编码',
                clearable: true
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        sequence: true,
        selectBtn: false,
        clickState: true,
        leftOperation: true,
        leftOperationWidth: 120,
        height: 400,
        rowKey: 'id',
        columns: [
            {
                label: '场景编码',
                align: 'center',
                prop: 'sceneCode',
                filter: true,
                require: true,
                sort: false,
                width: 150
            },
            {
                label: '场景名称',
                align: 'left',
                prop: 'sceneName',
                filter: true,
                require: true,
                sort: false,
                width: 200
            }, {
                label: '节点名称',
                align: 'left',
                prop: 'nodeName',
                filter: true,
                require: true,
                sort: false,
                width: 200
            },

            {
                label: '节点顺序',
                align: 'center',
                prop: 'nodeSequence',
                filter: true,
                require: true,
                sort: false,
                width: 80
            }, {
                label: '状态',
                align: 'center',
                prop: 'enableFlag',
                filter: true,
                require: true,
                sort: false,
                width: 90
            },

            {
                label: '来源系统',
                align: 'center',
                prop: 'sourceSys',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '扫码系统',
                align: 'center',
                prop: 'scanSys',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '调用方式',
                align: 'center',
                prop: 'invokeMethod',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '操作类型',
                align: 'center',
                prop: 'operateType',
                filter: true,
                require: true,
                sort: false,
                width: 120
            }, {
                label: '备注',
                align: 'center',
                prop: 'remark',
                filter: true,
                require: true,
                sort: false,
                width: 120
            },
            {
                label: '创建人',
                align: 'center',
                prop: 'createUserCode',
                filter: true,
                require: true,
                sort: false,
                width: 100
            },
            {
                label: '创建时间',
                align: 'center',
                prop: 'createTime',
                filter: true,
                require: true,
                sort: false,
                width: 100
            },
            {
                label: '更新人',
                align: 'center',
                prop: 'updateUserCode',
                filter: true,
                require: true,
                sort: false,
                width: 100
            },
            {
                label: '更新时间',
                align: 'center',
                prop: 'updateTime',
                filter: true,
                require: true,
                sort: false,
                width: 100
            }
        ],
        action: [
            {
                'type': 'text',
                'label': '修改',
                'size': 'small',
                'event': 'edit'
              },
              {
                'type': 'text',
                'label': '查看',
                'size': 'small',
                'event': 'detail'
              }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
